Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.SocialContentQuoteView extends Backbone.View
  template: JST["backbone/templates/monitoring/social_contents_v2/social_content_quote"]

  initialize: (options = {}) ->
      @avatar = options.avatar
      @author = options.author
      @username = options.username
      @text = options.text

  render: ->
    @$el.html @template { @avatar, @author, @username, @text }
    this
